// src/utils/poReceived.js
// MED-34 - which purchase orders count as a PURCHASE in the reports (pure, Jest).
//
// WHY THIS FILE EXISTS
// po.grand_total is the RECEIVED value (written by the GRN / Direct Site
// finalize). Until 30 Oct a new PO saved grand_total = its ordered subtotal,
// and the purchase reports added grand_total of EVERY PO - drafts, approved,
// ordered and cancelled ones counted as purchases. Old drafts on prod still
// carry that value, so a report must decide by "was it received", never by
// "grand_total > 0".
// Received = the GRN locked the PO (every GRN path sets grn_locked: true), or
// the PO is in a received status - incl. the old "short" / "over" names the
// PO list still counts as Completed.

export const RECEIVED_PO_STATUSES = ["completed", "short_closed", "over_received", "short", "over"];

export function isReceivedPO(po = {}) {
  if (!po) return false;
  if (po.grn_locked === true) return true;
  return RECEIVED_PO_STATUSES.includes(po.po_status || po.status);
}

// The PO's purchase value for a report: received value, 0 when not received.
export function receivedValueOf(po = {}) {
  if (!isReceivedPO(po)) return 0;
  const value = Number(po.grand_total || po.total_amount || 0);
  return Number.isFinite(value) ? value : 0;
}

// When the goods came: store GRN writes grn_completed_at, Direct Site
// finalize writes completed_at; very old POs have neither -> created_at.
export function receivedAtOf(po = {}) {
  return po.grn_completed_at || po.completed_at || po.created_at || null;
}
